import { inject, Pipe, PipeTransform } from "@angular/core";

import { Asset } from "@hermes/api-model-asset";
import { Settings } from "@hermes/core-app-core";
import { formatAssetUrl } from "@hermes/utils-generic-helpers";
import {
    ImageConfig,
    ImageUrlPipe,
} from "@hermes/utils-generic-pipes-image-url";

export const IMAGE_CONFIG_DESKTOP: ImageConfig = {
    width: 1040,
    quality: "40",
    sourceSet: false,
};

export const DEFAUT_IMAGE_PATH = "store-general";

@Pipe({
    name: "shopAssetsUrl",
})
export class ShopAssetUrlPipe implements PipeTransform {
    private settings = inject(Settings);
    private imagePipeUrl = inject(ImageUrlPipe);

    public transform(assets: Asset[]): Asset[] {
        const urls: string[] =
            assets?.length > 0
                ? assets.map((asset) => asset.url)
                : [`${this.settings.assetsUrlEditoImage}${DEFAUT_IMAGE_PATH}`];

        return urls
            .map((url) => formatAssetUrl(url))
            .map(
                (url) =>
                    new Asset(
                        this.imagePipeUrl.transform(url, IMAGE_CONFIG_DESKTOP),
                    ),
            );
    }
}
